import { __rest } from "tslib";
import React from 'react';
import Heading from '../Heading';
const HeadingMedium = (_a) => {
    var { Tag = 'h3', children, horizontalAlignment } = _a, props = __rest(_a, ["Tag", "children", "horizontalAlignment"]);
    return (React.createElement(Heading, Object.assign({ Tag: Tag, medium: true }, props, { horizontalAlignment: horizontalAlignment }), children));
};
export default HeadingMedium;
//# sourceMappingURL=HeadingMedium.js.map